var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsCloudformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2051,
    height: 2500,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CA9D",
    d: "m16.491 215.53 2.176 2.47 109.915 31.157.498-19.313-76.98-19.318-3.767-1.359-31.842 6.363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CA9D",
    d: "M239.505 215.53 127.25 253l-.334-23.156 76.979-19.318 3.355-3.776 32.255 8.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4929",
    d: "m126.916 83.165 76.979 17.941L237.75 99.5l1.755-3.393L132.25 57.5l-5.334 25.665"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "m52.1 210.526-35.609 5.004-.991-3.697V100l.991-3.893L48.667 98.5l3.433 2.61v109.416"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4929",
    d: "M129.08 83.165 52.1 101.106l-35.609-4.999L17.833 94l110.749-31.52.498 20.685"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B612C",
    d: "M127.846 0 0 64.531l.061 182.613 127.785 64.497 1.904-2.891v-305L127.846 0zM90.462 237.73l-73.971-22.2V96.107l73.971-22.192V237.73zm113.433-27.204 35.61 5.004L241.5 212V99.5l-1.995-3.393-35.61 5.003v109.416"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "m127.846 311.641 128.093-64.493L256 64.536 127.846 0v311.641zm37.687-237.726 73.972 22.192V215.53l-73.972 22.2V73.915z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudformation);
export default __webpack_public_path__ + "static/media/aws-cloudformation.4074008fac4125489677c1ec88ee60a4.svg";
export { ForwardRef as ReactComponent };